import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import DashboardLayout from "@/components/DashboardLayout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import PatientsPage from "@/pages/PatientsPage";
import TriagePage from "@/pages/TriagePage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import BillingPage from "@/pages/BillingPage";
import SettingsPage from "@/pages/SettingsPage";
import AuditLogPage from "@/pages/AuditLogPage";
import TenantsPage from "@/pages/TenantsPage";
import DoctorsPage from "@/pages/DoctorsPage";
import AppointmentsPage from "@/pages/AppointmentsPage";
import SurveyBuilderPage from "@/pages/SurveyBuilderPage";
import PublicFormPage from "@/pages/PublicFormPage";
import PatientJourneyPage from "@/pages/PatientJourneyPage";
import FollowUpsPage from "@/pages/FollowUpsPage";
import IntegrationsPage from "@/pages/IntegrationsPage";
import WidgetChatPage from "@/pages/WidgetChatPage";
import WidgetConfigPage from "@/pages/WidgetConfigPage";
import WhatsAppPage from "@/pages/WhatsAppPage";
import LandingPage from "@/pages/LandingPage";
import { Activity } from "lucide-react";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="flex items-center justify-center h-screen bg-white">
      <div className="text-center">
        <Activity className="w-8 h-8 text-sky-600 animate-pulse mx-auto mb-3" />
        <p className="text-sm text-slate-500">Loading engagingly.ai...</p>
      </div>
    </div>
  );
  return user ? children : <Navigate to="/login" replace />;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to="/dashboard" replace /> : children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/forms/public/:formId" element={<PublicFormPage />} />
          <Route path="/widget/chat" element={<WidgetChatPage />} />
          <Route element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/patients" element={<PatientsPage />} />
            <Route path="/triage" element={<TriagePage />} />
            <Route path="/doctors" element={<DoctorsPage />} />
            <Route path="/appointments" element={<AppointmentsPage />} />
            <Route path="/surveys" element={<SurveyBuilderPage />} />
            <Route path="/patient-journey" element={<PatientJourneyPage />} />
            <Route path="/follow-ups" element={<FollowUpsPage />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route path="/billing" element={<BillingPage />} />
            <Route path="/integrations" element={<IntegrationsPage />} />
            <Route path="/widget-config" element={<WidgetConfigPage />} />
            <Route path="/whatsapp" element={<WhatsAppPage />} />
            <Route path="/tenants" element={<TenantsPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/audit-logs" element={<AuditLogPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
